import styled from 'styled-components'

const StyledUserMenu = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 999999;
  padding: 20px;
  box-sizing: border-box;
  display: grid;
  align-items: center;
  justify-content: center;
  user-select: none;

  .backdrop {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
  }

  .menu {
    position: absolute;
    top: calc(70px - 6px);
    right: 16px;
    width: 220px;
    box-shadow: 0 2px 6px rgb(0, 0, 0, 0.1), 0 0 10px rgb(0, 0, 0, 0.1);
    background-color: ${({ theme }) => theme.color.background};
    border-radius: 10px;
    overflow: hidden;
    overflow-y: auto;

    .user-details-container {
      display: flex;
      align-items: center;
      padding: 16px;
      box-sizing: border-box;
      overflow: hidden;
      width: 100%;
      border-bottom: 1px solid ${({ theme }) => theme.color.gray[300]};

      .avatar {
        margin-right: 10px;
      }

      .user-details {
        span {
          display: -webkit-box;
          -webkit-line-clamp: 1;
          overflow: hidden;
          text-align: left;
          -webkit-box-orient: vertical;
          line-break: anywhere;
        }

        .user-name {
          font-weight: 600;
          font-size: 15px;
          color: ${({ theme }) => theme.color.gray[800]};
        }

        .user-email {
          font-size: 13px;
          margin-top: 4px;
          color: ${({ theme }) => theme.color.gray[500]};
        }
      }
    }

    .button-list {
      padding: 6px 0;
      display: grid;
      gap: 2px;

      hr {
        margin: 6px 0;
        border: 0;
        height: 1px;
        background-color: ${({ theme }) => theme.color.gray[300]};
      }

      button,
      a {
        display: flex;
        align-items: center;
        padding: 8px 10px;
        width: calc(100% - 12px);
        box-sizing: border-box;
        font-size: 14px;
        background-color: transparent;
        font-weight: 500;
        border-radius: 8px;
        margin: 0 6px;
        transition: 0.2s;
        text-decoration: none;
        color: ${({ theme }) => theme.color.gray[800]};

        svg {
          height: 18px;
          width: 18px;
          stroke-width: 2.2px;
          margin-right: 12px;
        }

        &:hover {
          background-color: ${({ theme }) => theme.color.gray[100]};
        }
      }
    }
  }
`

export default StyledUserMenu
